import SideBarButton from '../internal/sideBarButton';
import * as PropTypes from 'prop-types';

export default function SideBarMenu({buttons, activeButton, showSeperator}) {
    return (
        <div
            className="col col-1 card w-80px d-flex flex-direction-column align-items-center p-4 justify-content-between"
            style={{
                width: '80px important!',
                zIndex: 10,
                overflowY: 'auto',
                overflowX: 'hidden'
            }}
        >
            <div className="d-flex flex-direction-column align-items-center flex-column">
                {buttons
                    .filter((button) => button.top && !button.platform)
                    .map((button) => (
                        <div
                            style={{marginBottom: 15}}
                            key={button.icon}
                            className="position-relative"
                        >
                            <SideBarButton
                                icon={button.icon}
                                color={button.color}
                                text={button.text}
                                onClick={button.onClick}
                                active={button.name === activeButton || button?.currentlyActive}
                                disabled={!button.active}
                            />
                            {button.indicator && (
                                <div
                                    className="position-absolute  start-100 translate-middle badge rounded bg-warning"
                                    style={{fontSize: 10, bottom: -15}}
                                >
                                    {button.indicatorValue}
                                </div>
                            )}
                        </div>
                    ))}

                {showSeperator && (
                    <div className={"h-25px d-flex justify-content-center align-items-center w-100"}>
                    <div className={"w-100"}>
                        <div className={"bg-secondary rounded border border-secondary border-1 w-100"}></div>
                    </div>
                </div>
                )}

                <div className={'d-flex flex-column align-items-center my-5'}>
                    {buttons
                        .filter((button) => button.top && button.platform)
                        .map((button) => (
                            <div
                                style={{marginBottom: 15}}
                                key={button.icon}
                                className="position-relative"
                            >
                                <SideBarButton
                                    isPlatform={button.platform}
                                    icon={button.icon}
                                    color={button.color}
                                    text={button.text}
                                    onClick={button.onClick}
                                    active={button.name === activeButton || button?.currentlyActive}
                                    disabled={!button.active}
                                />
                                {button.indicator && (
                                    <div
                                        className="position-absolute  start-100 translate-middle badge rounded bg-warning"
                                        style={{fontSize: 10, bottom: -15}}
                                    >
                                        {button.indicatorValue}
                                    </div>
                                )}
                            </div>
                        ))}
                </div>
            </div>

            <div className="d-flex flex-direction-column align-items-center flex-column">
                {buttons
                    .filter((button) => !button.top)
                    .map((button) => (
                        <div
                            style={{marginBottom: 15}}
                            key={button.icon}
                            className="position-relative"
                        >
                            <SideBarButton
                                icon={button.icon}
                                text={button.text}
                                onClick={button.onClick}
                                active={button.name === activeButton || button?.currentlyActive}
                                disabled={!button.active}
                            />
                            {button.indicator && (
                                <div
                                    className="position-absolute  start-100 translate-middle badge rounded bg-warning"
                                    style={{fontSize: 10, bottom: -15}}
                                >
                                    {button.indicatorValue}
                                </div>
                            )}
                        </div>
                    ))}
            </div>
        </div>
    );
}

SideBarMenu.propTypes = {
    buttons: PropTypes.array.isRequired,
    activeButton: PropTypes.any,
    showSeperator: PropTypes.bool || null
};
